export interface SelectOption {
  value: number | string;
  label: string;
  disabled?: boolean;
}

export interface GSelectOption<T> {
  value: T;
  label: string;
}

export const filterLimitList: Array<SelectOption> = [
  { value: 10, label: '10개씩 보기' },
  { value: 30, label: '30개씩 보기' },
  { value: 50, label: '50개씩 보기' }
];

export const hours: Array<SelectOption> = [
  { value: 0, label: '오전 0시' },
  { value: 1, label: '오전 1시' },
  { value: 2, label: '오전 2시' },
  { value: 3, label: '오전 3시' },
  { value: 4, label: '오전 4시' },
  { value: 5, label: '오전 5시' },
  { value: 6, label: '오전 6시' },
  { value: 7, label: '오전 7시' },
  { value: 8, label: '오전 8시' },
  { value: 9, label: '오전 9시' },
  { value: 10, label: '오전 10시' },
  { value: 11, label: '오전 11시' },
  { value: 12, label: '오후 12시' },
  { value: 13, label: '오후 1시' },
  { value: 14, label: '오후 2시' },
  { value: 15, label: '오후 3시' },
  { value: 16, label: '오후 4시' },
  { value: 17, label: '오후 5시' },
  { value: 18, label: '오후 6시' },
  { value: 19, label: '오후 7시' },
  { value: 20, label: '오후 8시' },
  { value: 21, label: '오후 9시' },
  { value: 22, label: '오후 10시' },
  { value: 23, label: '오후 11시' }
];

export const minutes: Array<SelectOption> = [
  { value: 0, label: '00분' },
  { value: 5, label: '05분' },
  { value: 10, label: '10분' },
  { value: 15, label: '15분' },
  { value: 20, label: '20분' },
  { value: 25, label: '25분' },
  { value: 30, label: '30분' },
  { value: 35, label: '35분' },
  { value: 40, label: '40분' },
  { value: 45, label: '45분' },
  { value: 50, label: '50분' },
  { value: 55, label: '55분' }
];

export const searchTypeList: Array<SelectOption> = [
  {
    value: 'all',
    label: '전체'
  },
  {
    value: 'username',
    label: '환자명'
  },
  {
    value: 'phone',
    label: '연락처'
  }
];
